import type { SVGProps } from "react";

export default function InsightsIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.0833 16.2493H7.91667M12.0833 16.2493C12.0833 15.6548 12.0833 15.3574 12.1151 15.1602C12.2174 14.524 12.2353 14.4839 12.641 13.9833C12.7667 13.8281 13.2337 13.4099 14.1677 12.5737C15.4457 11.4293 16.25 9.76652 16.25 7.91602C16.25 4.46423 13.4517 1.66602 10 1.66602C6.54822 1.66602 3.75 4.46423 3.75 7.91602C3.75 9.76652 4.55425 11.4293 5.8323 12.5737C6.76621 13.4099 7.23322 13.8281 7.35902 13.9833C7.76468 14.4839 7.78258 14.524 7.88493 15.1602C7.91667 15.3574 7.91667 15.6548 7.91667 16.2493M12.0833 16.2493C12.0833 17.0282 12.0833 17.4176 11.9158 17.7077C11.8062 17.8977 11.6483 18.0555 11.4583 18.1652C11.1682 18.3327 10.7788 18.3327 10 18.3327C9.22117 18.3327 8.83175 18.3327 8.54167 18.1652C8.35167 18.0555 8.19384 17.8977 8.08413 17.7077C7.91667 17.4176 7.91667 17.0282 7.91667 16.2493"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
      <path
        d="M10.6548 7.08398L8.86914 9.58398H11.3691L9.58339 12.084"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
